<template>
  <div class="container_menu">
    <div class="menu" v-for="(item, index) in leftDataGroup" :key="index">
      <p class="menu-title flex">
        {{ item.name }}
        <span v-if="item.items.length > 5" class="expand-text" @click="handleDrop(index, item.drop)" style="margin-left: auto; cursor: pointer; color: #666; font-size: 12px;">
          {{ item.drop ? '收起' : '更多' }}
        </span>
        <!-- <i v-if="item.items.length > 5" :class="item.drop ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" @click="handleDrop(index, item.drop)"></i> -->
      </p>

      <ul class="menu-list">
        <el-checkbox-group v-model="checkedGroup" @change="getGrop">
          <li v-for="(element, idx) in item.items" :key="idx" v-show="idx < item.dropNum">
            <el-checkbox :label="element.onlyFlag" :key="idx">
              <span class="line1">{{ element.name }}</span>
              <span class="menu-result">{{ element.result }}</span>
            </el-checkbox>
          </li>
        </el-checkbox-group>
      </ul>
    </div>
    <!-- <div class="fixed" @click="handleCheckedGroup">
      执行限定条件<span v-show="checkedGroup.length > 0">{{ checkedGroup.length }}</span>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "LeftMenu",
  props: {
    leftData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    delName: {
      type: Object,
    },
    delSourceFrom: {
      type: Number,
    },
    delAll: {
      type: Number,
    },
  },
  watch: {
    leftData(val) {
      this.leftDataGroup = val;
      this.leftDataGroupCopy = this.leftDataGroup;
      this.readNum++;
    },
    delAll(val) {
      this.checkedGroup = [];
      this.checkedLetterName = "";
      this.sourceList = [];
    },
    delName(val) {
      // 删除选中的项
      this.checkedGroup.forEach((element, index) => {
        if (element == val.onlyFlag) {
          this.checkedGroup.splice(index, 1);
        }
      });
      //如果删除了首字母选项 左侧聚合取消选中
      let num = this.checkedGroup.filter(item => {
        return item == this.checkedLetterName.onlyFlag;
      });
      if (!num.toString()) {
        this.checkedLetterName = "";
      }
      this.checkedLetterName;
      this.handleCheckedGroup();
    },
    delSourceFrom(val) {
      this.sourceList = this.sourceList.filter(item => {
        return item != val;
      });
      this.getResouceVal();
    },
  },
  data() {
    return {
      readNum: 0,
      checkedGroup: [], //存储选中的checkbox
      leftDataGroup: [],
      leftDataGroupCopy: [], //左侧距和副本  当左侧距和为空时有用
      checkedLetterName: "", //存储选中的首字母名称
      filterArray: [], //根据选中的 获取到选中的过滤对象
      sourceList: [],
    };
  },

  mounted() {},
  methods: {
    getResouceVal() {
      this.$emit("sourceByValue", this.sourceList);
    },
    getGrop() {
      if (this.checkedGroup.length > 5) {
        this.checkedGroup.forEach((element, index) => {
          if (index > 4) {
            this.checkedGroup.splice(index, 1);
            this.$message.warning("限定条件不能超过5个");
          }
        });
        return;
      }
      this.handleCheckedGroup();
    },
    handleDrop(index, flag) {
      //如果是展开状态 - 收起
      if (flag) {
        this.$set(this.leftDataGroup[index], "drop", false);
        this.leftDataGroup[index].dropNum = 5;
        return;
      }
      // 最多展开20条
      this.leftDataGroup[index].dropNum = 20;
      this.$set(this.leftDataGroup[index], "drop", true);
    },

    handleCheckedGroup() {
      this.filterArray = [];
      this.checkedGroup.forEach(element => {
        this.leftDataGroupCopy.forEach((item, index) => {
          item.items.forEach(ele => {
            ele.fatherName = item.name;
            if (element == ele.onlyFlag) {
              this.filterArray.push(ele);
            }
          });
        });
      });

      // 如果有相同分类 合并
      var res = [];
      var narr = [];
      var metArr = [];
      for (var i = 0; i < this.filterArray.length; i++) {
        metArr.push({
          filterField: this.filterArray[i].filterField,
          fatherName: this.filterArray[i].fatherName,
          filterValue: [this.filterArray[i].filterValue],
          name: this.filterArray[i].name,
          onlyFlag: this.filterArray[i].onlyFlag,
        });
      }
      narr = narr.concat(metArr);

      if (this.checkedLetterName) {
        narr.push(this.checkedLetterName);
        this.filterArray.push(this.checkedLetterName);
      }

      let obj = {
        filterArray: this.filterArray,
        newNarr: narr,
      };
      //选中的checkbox数组 传给父组件
      this.$emit("childByValue", obj);
    },
  },
};
</script>

<style lang="scss" scoped>
.container_menu {
  max-width: 250px;
  position: relative;
  margin-right: 20px;
  min-height: 600px;

  .menu-letter {
    background: #fff;
    padding: 0 20px;
    margin-bottom: 10px;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: linear-gradient(90deg, #006eb3 0%, #2d8cf0 100%) #2d8cf0;
    }
    .checked {
      color: #006eb3;
    }
    .menu-title {
      padding: 15px 0;
    }
    .menu-num {
      border-top: 1px solid #e6e6e6;
      font-size: 14px;
      padding: 5px 0;
      cursor: pointer;
    }
    .menu-ul {
      flex-wrap: wrap;
      li {
        cursor: pointer;
        width: 30px;
        font-size: 14px;
        line-height: 25px;
      }
    }
    .menu-other {
      font-size: 14px;
      padding: 5px 0 10px 0;
      cursor: pointer;
    }
  }

  .menu {
    background: #fff;
    padding: 0 20px;
    margin-bottom: 10px;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: linear-gradient(90deg, #006eb3 0%, #2d8cf0 100%) #2d8cf0;
    }
    .menu-title {
      padding: 15px 0;
      i {
        margin-left: auto;
        font-size: 20px;
        color: #666;
        cursor: pointer;
      }
    }
    .menu-list {
      border-top: 1px solid #e6e6e6;
      font-size: 14px;
      padding-bottom: 20px;
      padding-top: 10px;
      li {
        display: flex;
        align-items: center;
        margin-top: 10px;
        cursor: pointer;
        ::v-deep .el-checkbox {
          color: #333;
          display: flex;
          align-items: center;
          width: 100%;
        }
        ::v-deep .el-checkbox__label {
          display: flex;
          flex: 1;
          min-width: 0;
        }
        .menu-result {
          margin-left: auto;
          color: #999999;
        }
      }
    }
  }
  .fixed {
    position: fixed;
    top: 45%;
    left: 15%;
    background: #006eb3;
    width: 50px;
    color: #fff;
    font-size: 12px;
    padding: 10px;
    border-radius: 3px;
    text-align: center;
    box-shadow: 0px 0px 5px 0px rgba(161, 29, 29, 0.4);
    cursor: pointer;
    span {
      position: absolute;
      top: -10px;
      left: -10px;
      background: #006eb3;
      border: 1px solid #fff;
      border-radius: 50%;
      width: 20px;
      height: 20px;
    }
  }
}
</style>
